var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"mt-4",attrs:{"headers":_vm.headers,"items":_vm.debtors,"hide-default-footer":"","items-per-page":-1,"mobile-breakpoint":0}})
}
var staticRenderFns = []

export { render, staticRenderFns }